import { Box, Button, Stack, TextField } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { ORDER_TYPES_VALUES } from "../../constants/enums";
import {
  addCustomer,
  clearActiveOrderUidInSession,
  clearCart,
  searchCustomer,
  setCustomerDetails,
  setOrderType,
} from "../../reduxStore/slices/cartSlice";
import { useNotify } from "../../utils/snackbarUtils";
import AppButton from "../app-button/AppButton";
import AppDialog from "../app-dialog/AppDialog";
import OrderTypeSelector from "../order-type-selector/OrderTypeSelector";

function NewOrderDialog({ isNewOrderDialogOpen, onDialogCancel }) {
  const { showSuccess, handleApiError, showError } = useNotify();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { loading: isLoading, customerSearchResults: customerData } =
    useSelector((state) => state.cart);

  const [id, setId] = useState("");
  const [uid, setUid] = useState("");
  const [selectedOrderType, setSelectedOrderType] = useState({
    type: ORDER_TYPES_VALUES[0].value,
  });
  const [isNewOrderLoading, setIsNewOrderLoading] = useState(false);
  const [customerMobileNo, setCustomerMobileNo] = useState("");
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [isExistingCustomer, setIsExistingCustomer] = useState(false);

  useEffect(() => {
    if (
      customerData &&
      customerData.id &&
      customerMobileNo &&
      customerMobileNo.length === 10
    ) {
      // Existing customer → prefill form
      setId(customerData.id || "");
      setUid(customerData.uid || "");
      setFirstName(customerData.first_name || "");
      setLastName(customerData.last_name || "");
      setIsExistingCustomer(true);
    } else {
      // No customer → reset form
      setIsExistingCustomer(false);
      resetFields();
    }
  }, [customerData]);

  const handleMobileChange = async (e) => {
    const value = e.target.value.replace(/\D/g, "");
    setCustomerMobileNo(value);

    if (value.length === 10) {
      try {
        await dispatch(searchCustomer({ mobileNo: value })).unwrap();
      } catch (err) {
        console.log("No customer found, can create new.");
      }
    }
  };

  const handleCreateNewOrder = async () => {
    if (customerMobileNo !== "") {
      if (customerMobileNo.length !== 10) {
        showError("Please enter valid Mobile number.");
        return;
      }
      if (firstName === "") {
        showError("Please enter First name.");
        return;
      }
      setIsNewOrderLoading(true);
      if (customerData && customerData.mobile_no) {
        dispatch(setCustomerDetails(customerData));
      } else {
        try {
          const obj = {
            id,
            uid,
            mobile_no: customerMobileNo,
            first_name: firstName,
            last_name: lastName,
          };

          const res = await dispatch(addCustomer(obj)).unwrap();
          obj["id"] = res.id;
          dispatch(setCustomerDetails(obj));
        } catch (err) {
          handleApiError(err);
        }
      }
    }
    dispatch(clearCart());
    clearActiveOrderUidInSession();
    dispatch(setOrderType({ type: selectedOrderType.type }));
    if (selectedOrderType.type === 1) {
      navigate(`/app/tables`);
    } else {
      navigate(`/app/menu`);
    }
    setIsNewOrderLoading(false);
    resetFields();
    onDialogCancel();
  };

  const resetFields = () => {
    setFirstName("");
    setLastName("");
    setSelectedOrderType({ type: ORDER_TYPES_VALUES[0].value });
  };

  const handleOrderTypeSelected = (orderType) => {
    setSelectedOrderType(orderType);
  };

  const dialogNewOrderFooter = (
    <>
      <Box
        style={{
          display: "flex",
          gap: 15,
        }}
      >
        <Button size="medium" onClick={onDialogCancel}>
          Cancel
        </Button>
        <AppButton
          disabled={isNewOrderLoading}
          isLoading={isNewOrderLoading}
          fullWidth
          size="medium"
          variant="contained"
          onClick={handleCreateNewOrder}
        >
          Create
        </AppButton>
      </Box>
    </>
  );

  return (
    <>
      <AppDialog
        maxWidth="xs"
        isOpen={isNewOrderDialogOpen}
        id={"new_order_dialog"}
        title={<>{"Create New Order"}</>}
        footer={dialogNewOrderFooter}
      >
        <Box>
          <Box>
            <OrderTypeSelector
              type={"header"}
              selectedOrderType={selectedOrderType}
              onOrderTypeSelected={handleOrderTypeSelected}
            />
          </Box>
          <Box>
            <Box>
              <Stack
                spacing={3}
                style={{
                  marginTop: 15,
                  marginBottom: 15,
                }}
              >
                <TextField
                  autoFocus
                  label="Customer Mobile No.(Optional)"
                  fullWidth
                  placeholder=""
                  autoComplete="T-customer-mobile-no"
                  name="customer_mobile_no"
                  type="number"
                  value={customerMobileNo}
                  onChange={handleMobileChange}
                />
                {customerMobileNo && customerMobileNo.length >= 10 && (
                  <Box sx={{ display: "flex", gap: 2 }}>
                    <TextField
                      autoComplete="T-customer-first-name"
                      label="First Name *"
                      variant="outlined"
                      value={firstName}
                      onChange={(e) => setFirstName(e.target.value)}
                      disabled={isExistingCustomer}
                    />
                    <TextField
                      autoComplete="T-customer-last-name"
                      label="Last Name(Optional)"
                      variant="outlined"
                      value={lastName}
                      onChange={(event) => setLastName(event.target.value)}
                      disabled={isExistingCustomer}
                    />
                  </Box>
                )}
              </Stack>
            </Box>
          </Box>
        </Box>
      </AppDialog>
    </>
  );
}

export default NewOrderDialog;
